module.exports = __webpack_public_path__ + "static/media/architectimg.f5f9b0af.png";